// src/utils/colors.js

export const SEX_COLORS = { M: "#004c3f", W: "#fdc300" };

export const TNM_COLORS = {
  is: "#006e35",
  a: "#404040",
  "0": "#004c3f",
  "1": "#5f7215",
  "2": "#f0ad00",
  "3": "#ef7d00",
  "4": "#c33015",
  X: "#d0d0cf",
};


export const UICC_COLORS = {
  "0": "#004c3f",
  I: "#5f7215",
  II: "#f0ad00",
  III: "#ef7d00",
  IV: "#c33015",
  X: "#d0d0cf",
};

export const SURVIVAL_STAGE_COLORS = {
  "0": "#004c3f",
  I: "#5f7215",
  II: "#f0ad00",
  III: "#ef7d00",
  IV: "#c33015",
  X: "#d0d0cf",
};



export const PALETTE_GRADING = {
  G1: "#004c3f",
  Low: "#5f7215",
  G2: "#f0ad00",
  Medium: "#ef7d00",
  "G3/4/High": "#c33015",
  GX: "#d0d0cf",
};

export const PALETTE_GLEASON = {
  "1-6": "#004c3f",
  "7a": "#5f7215",
  "7b": "#f0ad00",
  "8": "#ef7d00",
  "9-10": "#c33015",
  X: "#d0d0cf",
};

export const PALETTE_CLARK = {
  "L I": "#004c3f",
  "L II": "#5f7215",
  "L III": "#f0ad00",
  "L IV": "#ef7d00",
  "L V": "#c33015",
  "L X": "#d0d0cf",
};



export const LOKALISATION_COLORS = [
  "#004c3f", 
  "#7ec399", 
  "#c9e8fb",
   "#cf9fc7",
"#8464a4",
"#fdc300", 
   "#53ad86",
  "#c3ddcd",
   "#3e8a7f",
    "#6aa9d0", 
    "#e2d6c2",
    "#cf9fc7",


  "#6b6ecf", 
  "#b5cf6b",
   "#e7cb94",
    "#ad494a",
     "#8c6d31",
  "#393b79", 
  "#637939",
   "#843c39", 
   "#7b4173", 
   "#5254a3",
];



export const HISTOLOGY_COLORS = [
  "#004c3f",
  "#7ec399",
  "#fdc300",
  "#cf9fc7",
  "#c9e8fb",
  "#70b8ba",
  "#f59f42",
  "#f9d2e5",
  "#70b8ba",
  "#8fbe00",
  "#b45f06",
  "#741b47",
];



export const METASTASIS_COLORS = [
  "#004c3f",
  "#fdc300",
  "#cf9fc7",
  "#7ec399",
  "#f9d2e5",
  "#f59f42",
  "#c9e8fb",
  "#e2d6c2",
  "#8464a4",
  "#c3ddcd",
  "#a64d79",
  "#6aa84f",
];




export const THERAPY_COLORS = {
  "Alleinige OP": ["#51746a"],
  "Alleinige Strahlentherapie": ["#f0ad00"],
  "Chemo-/Immuntherapie": ["#ef7d00"],
  "Bestrahlung und Chemo-/Immuntherapie": ["#c75113"],
  "Operation und Bestrahlung": ["#A19135"],
  "Operation und Chemo-/Immuntherapie": ["#A07935"],
  "Operation, Bestrahlung und Chemo-/Immuntherapie": ["#543918"],

  // exact color for "keine gemeldete Primärtherapie"
  NO_INFO: ["#d0d0cf"],

  // fallback for unknown therapy groups
  FALLBACK: ["rgba(150, 150, 150, 0.7)"],
};

export const MALE_ENTIT_COLORS = {
  Prostata: "#70b8ba",
  Lunge: "#c9e8fb",
  Kolon: "#7ec399",
  Harnblase: "#fdc300",
  Rektum: "#c3ddcd",
  Magen: "#e2d6c2",
  Niere: "#8464a4",
  Bauchspeicheldrüse: "#3e8a7f",
  "Malignes Melanom der Haut": "#cf9fc7",
  Leber: "#f59f42",
  Myelom: "#323f8bff",
  "Non-Hodgkin-Lymphom": "#6b91b3",
  "Chronische lymphatische Leukämie": "#690606ff",
  Sonstige: "#004c3f"
};

export const FEMALE_ENTIT_COLORS = {
  Brustdrüse: "#c1647d",
  Leber: "#f59f42",
  Niere: "#8464a4",
  Rektum: "#c3ddcd",
  Magen: "#e2d6c2",
  "Malignes Melanom der Haut": "#cf9fc7",
  Harnblase: "#fdc300",
  Bauchspeicheldrüse: "#3e8a7f",
  Gebärmutterkörper: "#f9d2e5",
  Kolon: "#7ec399",
  Lunge: "#c9e8fb",
  Myelom: "#323f8bff",
  "Chronische lymphatische Leukämie": "#690606ff",
  "Non-Hodgkin-Lymphom": "#745DAA",
  Sonstige: "#004c3f",
  Eierstöke: "#e3e3e3"
};



const FALLBACK = "#6b7280";


export function colorForEntit(entit, sex) {
  if (!entit) return FALLBACK;
  if (sex === "M" && MALE_ENTIT_COLORS[entit]) return MALE_ENTIT_COLORS[entit];
  if (sex === "W" && FEMALE_ENTIT_COLORS[entit]) return FEMALE_ENTIT_COLORS[entit];
  if (MALE_ENTIT_COLORS[entit]) return MALE_ENTIT_COLORS[entit];
  if (FEMALE_ENTIT_COLORS[entit]) return FEMALE_ENTIT_COLORS[entit];

  return FALLBACK;
}

